import { render, staticRenderFns } from "./FormDataTool.vue?vue&type=template&id=2b39c2e7&"
import script from "./FormDataTool.vue?vue&type=script&lang=js&"
export * from "./FormDataTool.vue?vue&type=script&lang=js&"
import style0 from "./FormDataTool.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports